import {PdsWidget} from './pds-widget';
export class PdsImg extends PdsWidget {
  is = 'pds-img';
  src: string;
  fallbackIconName: string;
  useImage: boolean;
  alt: string;
  width: number;
  height: number;
  maintainAspectRatio: boolean;
  scopeClass: string;
  imageHadErrors: boolean;

  // need properties to bind attributes without javascript
  properties = {
    src: {
      type: String,
      value: null,
      observer: 'srcIsSet'
    },
    fallbackIconName: String,
    useImage: {
      type: Boolean,
      value: true
    },
    alt: String,
    width: Number,
    height: Number,
    //Not a public input.
    imageHadErrors: {
      value: false
    }
  };

  ready(): void {
    super.ready();
    this.alt = 'PowerSchool image';
  }

  srcIsSet(): void {
    this.imageHadErrors = false; // With a new src, we give it a new chance to get errors
    setTimeout(() => {
      this.redraw('imageHadErrors');
    });
  }

  onImageError(): void {
    //this is called when src is invalid
    this.imageHadErrors = true;
  }

  showImg(): boolean {
    return this.imageHadErrors === false && this.useImage && this.src != null;
  }

  attached(): void {
    super.attached();
    //Setting timeout here to allow angular 2 to bind the property correctly.
    setTimeout(() => {
      if (this.fallbackIconName == null || this.fallbackIconName.length === 0) {
        throw 'Must configure a fallBackIconName';
      }
      if (this.useImage && this.src == null) {
        throw 'Use Image is set to true, but no image source was specified.';
      }
    });
  }
}
